// Location Intelligence Types

export interface ClientLocation {
  id: string;
  client_id: string;
  user_id: string;
  organization_id: string | null;
  label: string;
  street_address: string | null;
  street_address_2: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
  country: string;
  latitude: number | null;
  longitude: number | null;
  is_primary: boolean;
  geocode_status: GeocodeStatus;
  geocode_source: string | null;
  created_at: string;
  updated_at: string;
}

export interface TrainerLocation {
  id: string;
  user_id: string;
  organization_id: string | null;
  label: string;
  street_address: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
  country: string;
  latitude: number | null;
  longitude: number | null;
  is_home_base: boolean;
  service_radius_miles: number;
  created_at: string;
  updated_at: string;
}

export type GeocodeStatus = "pending" | "success" | "failed" | "manual";

export interface GeocodedAddress {
  street_address: string;
  street_address_2?: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  latitude: number;
  longitude: number;
  formatted_address: string;
}

export const LOCATION_LABELS = [
  "Home",
  "Work",
  "Gym",
  "Park",
  "Other",
] as const;

export type LocationLabel = (typeof LOCATION_LABELS)[number];

export interface LatLng {
  lat: number;
  lng: number;
}

export interface RouteStop {
  id: string;
  client_id: string;
  client_name: string;
  location: ClientLocation;
  session_time: string;
  duration_minutes: number;
}

export interface OptimizedRoute {
  stops: RouteStop[];
  total_distance_miles: number;
  total_duration_minutes: number;
  polyline: string;
  time_saved_minutes: number;
}
